import { render, staticRenderFns } from "./MainAppStackBarGraph.vue?vue&type=template&id=8c838eae&scoped=true&"
import script from "./MainAppStackBarGraph.vue?vue&type=script&lang=ts&"
export * from "./MainAppStackBarGraph.vue?vue&type=script&lang=ts&"
import style0 from "./MainAppStackBarGraph.vue?vue&type=style&index=0&id=8c838eae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c838eae",
  null
  
)

export default component.exports